module.exports = __webpack_public_path__ + "static/media/icon-apple.7bcd6fe0.svg";